import { ArticleSearchResultItem, NormalizedResource, SearchResultItem } from "../types";
import { stripHTML } from "./text";

export const normalizedResourceToSearchResultItem = (resource: NormalizedResource): SearchResultItem => ({
    title: resource.title,
    description: stripHTML(resource.description),
    url: removeDoubleSlashURL(resource.url),
    type: resource.source
});

const removeDoubleSlashURL = (url: string) => url.replace(/([^:]\/)\/+/g, '$1');

export const articleSearchResultToSearchResultItem = (article: ArticleSearchResultItem): SearchResultItem => ({
    id: article.id,
    title: article.title,
    description: article.description,
    url: article.url,
    uri: article.uri,
    type: article.type
});
